import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {

   activeTaskTab: string = 'management';
  taskTabIndex: number = 0;

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    const selectedTaskTab = localStorage.getItem('selectedTaskTab');

    if (selectedTaskTab != null) {
      this.activeTaskTab = selectedTaskTab;
      if (selectedTaskTab === 'paralegal')
        this.taskTabIndex = 1;
      else if (selectedTaskTab === 'admin')
        this.taskTabIndex = 2;
      else
        this.taskTabIndex = 0;
    } else {
      // Default to paralegal tab for non-managers
      if (!this.authService.isPortalManager() && !this.authService.isPortalParaLegalTL()) {
        this.activeTaskTab = this.authService.canSeeParalegalActionList() ? 'paralegal' : 'admin';
      }
    }
  }

  setActiveTab(tab: string): void {
    this.activeTaskTab = tab;
    localStorage.setItem('selectedTaskTab', tab);
  }

}
